import { Button, Col, Form, Row } from "react-bootstrap";
import Card from "../../../../../components/bootstrap/card";
import CommaFormattedInput from "../../../../../components/form/CommaFormattedInput";
import { useState } from "react";

const InstructorWageIndividualForm = ({
  formData, individualLessonDiscountPrice, handleLessnDataChange, individualLessonCounts, individualOptionCounts
}) => {
  const [sortOrder, setSortOrder] = useState('name'); // 'name', 'count', 'option'
  const [sortDirection, setSortDirection] = useState('asc'); // 'asc', 'desc'

  const handleSort = (order) => {
    if (sortOrder === order) {
      // 같은 정렬을 다시 클릭하면 방향 토글
      setSortDirection(prev => prev === 'asc' ? 'desc' : 'asc');
    } else {
      // 다른 정렬을 클릭하면 오름차순으로 초기화
      setSortOrder(order);
      setSortDirection('asc');
    }
  };

  const getSortedEntries = () => {
    if (!individualLessonCounts) return [];
    
    return Object.entries(individualLessonCounts).sort(([keyA, valueA], [keyB, valueB]) => {
      const [nameA, optionA] = keyA.split('|').map(str => str.trim());
      const [nameB, optionB] = keyB.split('|').map(str => str.trim());
      
      let result = 0;
      switch (sortOrder) {
        case 'name':
          result = nameA.localeCompare(nameB, 'ko');
          break;
        case 'count':
          result = valueA - valueB; // 기본은 오름차순
          break;
        case 'option':
          result = optionA.localeCompare(optionB, 'ko');
          break;
        default:
          return 0;
      }
      
      // 내림차순이면 결과 반전
      return sortDirection === 'desc' ? -result : result;
    });
  };

  return (
  <Card>
    <Card.Header className="d-flex justify-content-between">
      <div className="header-title">
        <h4 className="card-title">개인레슨</h4>
      </div>
    </Card.Header>
    <Card.Body>
      <div className="new-user-info">
        <div className="row">
          <Form.Group className="col-md-12 form-group">
            <Form.Label htmlFor="fname">금액 합계</Form.Label>
            <CommaFormattedInput
              name="individualPrice"
              value={formData.individualPrice}
              onChange={handleLessnDataChange}
              disabled={true}
            />
          </Form.Group>
          {/* <Form.Group className="col-md-6 form-group">
            <Form.Label htmlFor="fname">참여인원</Form.Label>
            <Form.Control
              type="number"
              name="individualCount"
              value={formData.individualCount}
              onChange={handleLessnDataChange}
              disabled={true}
            />
          </Form.Group>
          <Form.Group className="col-md-6 form-group">
            <Form.Label htmlFor="fname">운용레슨수</Form.Label>
            <Form.Control
              type="number"
              name="individualLessonCount"
              value={formData.individualLessonCount}
              onChange={handleLessnDataChange}
              disabled={true}
              required
            />
          </Form.Group> */}
        </div>
        <div className="row mt-2">
          <div className="col-md-12">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <Form.Label className="fw-bold mb-0">참여인원</Form.Label>
              <div className="btn-group" role="group">
                <Button 
                  variant={sortOrder === 'name' ? 'primary' : 'outline-primary'} 
                  size="sm"
                  onClick={() => handleSort('name')}
                >
                  이름순 {sortOrder === 'name' && (sortDirection === 'asc' ? '↑' : '↓')}
                </Button>
                <Button 
                  variant={sortOrder === 'count' ? 'primary' : 'outline-primary'} 
                  size="sm"
                  onClick={() => handleSort('count')}
                >
                  인원순 {sortOrder === 'count' && (sortDirection === 'asc' ? '↑' : '↓')}
                </Button>
                {/* <Button 
                  variant={sortOrder === 'option' ? 'primary' : 'outline-primary'} 
                  size="sm"
                  onClick={() => handleSort('option')}
                >
                  옵션순 {sortOrder === 'option' && (sortDirection === 'asc' ? '↑' : '↓')}
                </Button> */}
              </div>
            </div>
            <div>
              {individualLessonCounts && Object.keys(individualLessonCounts).length > 0 ? (
                getSortedEntries().map(([key, value], index) => {
                  const [name, option] = key.split('|').map(str => str.trim());
                  const badgeColor = option === 'MSIC' ? 'bg-info text-dark' : option === 'MOTC' ? 'bg-light' : 'bg-secondary text-white';
                  const customStyle = option === 'MOTC' ? {
                    backgroundColor: '#e3f2fd', 
                    color: '#1976d2',
                    border: '1px solid #bbdefb'
                  } : {};
                  return (
                    <div key={key} className="d-flex align-items-center justify-content-between bg-light rounded px-2 py-1 mb-1 border">
                      <span className="d-flex align-items-center">
                        <span className="fw-semibold text-dark">{name}</span>
                        <span className={`badge ${badgeColor} ms-2`} style={customStyle}>{option}</span>
                      </span>
                      <span className="badge bg-primary fs-6">{value}</span>
                    </div>
                  );
                })
              ) : (
                <div className="text-center text-muted py-1">데이터 없음</div>
              )}
            </div>
            <Form.Label className="fw-bold mt-3 mb-2">운용레슨수</Form.Label>
            <div>
              {individualOptionCounts && Object.keys(individualOptionCounts).length > 0 ? (
                Object.entries(individualOptionCounts).map(([key, value]) => (
                  <div key={key} className="d-flex align-items-center justify-content-between bg-light rounded px-2 py-1 mb-1 border">
                    <span className="fw-semibold text-dark">{key}</span>
                    <span className="badge bg-success fs-6">{value}</span>
                  </div>
                ))
              ) : (
                <div className="text-center text-muted py-1">데이터 없음</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Card.Body>
  </Card>
  );
};

export default InstructorWageIndividualForm;
